import React from 'react'
import { Link } from "react-router-dom"
import { Helmet } from "react-helmet"
import axios from "axios"
import { Field as FormikField, Form as FormikForm, Formik, FormikProps, ErrorMessage } from 'formik';
import { ToastContainer } from 'react-toastify';
import { ReactComponent as Arrow } from "../assets/arrow.svg"

import Title from "../components/global/Title/Title"
import Notification from "../components/global/Notification/Notification"
import Content from "../components/global/Content/Content"
import Button from "../components/global/Button/Button"
import Animation from "../components/global/Animation/Animation"

import { Loader } from "../components/common/Loader/Loader"

import * as Yup from 'yup';

const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

const ContactSchema = Yup.object().shape({
 name: Yup.string()
   .min(2, 'De ingevulde naam is te kort.')
   .max(50, 'De ingevulde naam is te lang')
   .required('Naam is verplicht.'),
 phone: Yup.string()
   .min(8, 'Minimaal 8 tekens vereist')
   .matches(phoneRegExp, 'Telefoonnummer niet geldig.')
   .required('Telefoonnummer is vereist'),
 email: Yup.string()
   .typeError('E-mailadres is verplicht.')
   .email('Geen geldig e-mailadres')
   .required('E-mailadres is verplicht.'),
 category: Yup.string()
   .typeError('Keuze is verplicht.')
   .required('Keuze is verplicht.'),
 message: Yup.string()
 .max(1000, 'Dit bericht is te lang. Maximaal 1000 karakters toegestaan!')
 .required('Een bericht of opmerking is verplicht.'),
});

export default class ContactScreen extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      data: [],
      loading: false,
      values: {},
      emailSent: false,
      error: null,
    }
  }

  componentDidMount() {
    this.loadData()
  }

  loadData = () => {
    this.setState({loading: true})

    axios.get('/wp-json/wp/v2/pages/109')
      .then( res => { this.setState({ data: res.data, loading: false })})
      .catch(error => { console.log(error) })
  }

  render () {
    const { data, loading } = this.state

    const options = [
      { key: 1, title: "Algemeen" },
      { key: 2, title: "Bestuur" },
      { key: 3, title: "Communicatie" },
      { key: 4, title: "Funding" },
      { key: 5, title: "Stichting" },
      { key: 6, title: "Uitbreiding" },
    ]
    return (
      loading === true ? <Loader/> :
      <div>
        <Helmet>
          <title>{data.yoast_title && data.yoast_title}</title>
          <meta name={data.yoast_meta && data.yoast_meta[0].name} content={data.yoast_meta && data.yoast_meta[0].content} />
        </Helmet>
        <section className="relative p-0 pt-16">
          <Animation/>
          <div className="max-w-screen-xl mx-auto sm:px-4 md:px-6 md:flex md:flex-wrap lg:px-8 z-10 relative">
            <div className="ml-1-col w-3/4 py-32">
              <div className="breadcrumb-bar" style={{color: "#F58120"}}>
                <div className="breadcrumb"><Link to="/">Home</Link><div className="px-2 breadcrumb-seperator"><Arrow/></div></div>
                <div className="breadcrumb" style={{color: "#000"}}>Contact</div>
              </div>
              <Title level="1" className="underlined">{ data.title && data.title.rendered }</Title>
              <Content className="mt-10 xs:w-full w-2/3">{ data.content && data.content.rendered }</Content>
            </div>
            <div className="w-full">
              <div className="mx-4 rounded-lg">
                <Formik
                  initialValues={{ name: '', email: '', phone: '', category: options[0].title, message: ''}}
                  validationSchema={ContactSchema}
                  onSubmit={(values, { actions, resetForm}) => {
                    this.setState({values: values})
                    // alert(JSON.stringify(this.state.values, null, 2));
                    axios.post('/wp-json/rondetafel/v2/contact_submit', values, {
                      headers: {
                        'Content-Type': 'application/json',
                      }
                    })
                    .then(response => {
                      // console.log(response)
                    })
                    .catch(error => {
                      console.log(error)
                    })
                    Notification(1, "Bericht verstuurd")
                    this.setState({emailSent: true})
                    resetForm({ values: '' })
                  }}
                  >
                  <FormikForm className="bg-lightorange rounded md:py-16 md:px-20 xs:py-8 xs:px-10 mb-4" method="POST">
                    <div className="flex flex-wrap -mx-3 mb-2">
                      <div className="w-full md:w-1/2 px-3">
                        <FormikField name="name">
                          {({ field, form: { touched, errors }, meta, }) => (
                            <div>
                              <input placeholder="Naam" type="text" className={`appearance-none block w-full active:bg-white-100 rounded my-2 px-8 py-6 focus:outline-none focus:bg-white ${meta.touched && meta.error ? 'invalid' : null}`} {...field} />
                              <div className={`${meta.touched && meta.error ? 'display-block invalid-message' : 'display-none'} rounded h-8 mb-2 text-xs ease-in-out duration-300`}><ErrorMessage name="name"/></div>
                            </div>
                          )}
                        </FormikField>
                      </div>
                      <div className="w-full md:w-1/2 px-3">
                        <FormikField name="email">
                          {({ field, form: { touched, errors }, meta, }) => (
                            <div>
                              <input placeholder="E-mailadres" type="email" className={`appearance-none block w-full active:bg-white-100 rounded my-2 px-8 py-6 focus:outline-none focus:bg-white ${meta.touched && meta.error ? 'invalid' : null}`} {...field}/>
                              <div className={`${meta.touched && meta.error ? 'display-block invalid-message' : 'display-none'} rounded h-8 mb-2 text-xs ease-in-out duration-300`}><ErrorMessage name="email"/></div>
                            </div>
                          )}
                        </FormikField>
                      </div>
                    </div>

                    <div className="flex flex-wrap -mx-3 mb-2">
                      <div className="w-full md:w-1/2 px-3">
                        <FormikField name="phone">
                          {({ field, form: { touched, errors }, meta, }) => (
                            <div>
                              <input placeholder="Telefoonnummer" type="text" maxLength="12" className={`appearance-none block w-full active:bg-white-100 rounded my-2 px-8 py-6 focus:outline-none focus:bg-white ${meta.touched && meta.error ? 'invalid' : null}`} {...field}/>
                              <div className={`${meta.touched && meta.error ? 'display-block invalid-message' : 'display-none'} rounded h-8 mb-2 text-xs ease-in-out duration-300`}><ErrorMessage name="phone"/></div>
                            </div>
                          )}
                        </FormikField>
                      </div>
                      <div className="w-full md:w-1/2 px-3">
                        <FormikField name="category">
                          {({ field, form: { touched, errors }, meta, }) => (
                            <div>
                              <div className="inline-block relative w-full">
                                <select placeholder="Maak een keuze" required className={`appearance-none block w-full active:bg-white-100 rounded my-2 px-8 py-6 bg-white focus:outline-none focus:bg-white ${meta.touched && meta.error ? 'invalid' : null}`} {...field}>
                                  {options && options.map(prop => (
                                    <option key={prop.key} value={prop.title}>{prop.title}</option>
                                  ))}
                                </select>
                                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-8 text-gray-700">
                                  <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                                </div>
                              </div>

                              <div className={`${meta.touched && meta.error ? 'display-block invalid-message' : 'display-none'} rounded h-8 mb-2 text-xs ease-in-out duration-300`}><ErrorMessage name="category"/></div>
                            </div>
                          )}
                        </FormikField>
                      </div>
                    </div>

                    <div className="flex flex-wrap -mx-3 px-3 my-2">
                      <div className="w-full">
                        <FormikField name="message">
                          {({ field, form: { touched, errors }, meta, }) => (
                            <div>
                              <textarea placeholder="Bericht" rows={4} className={`appearance-none block w-full resize-none active:bg-white-100 rounded my-2 px-8 py-6 focus:outline-none focus:bg-white ${meta.touched && meta.error ? 'invalid' : null}`} {...field}/>
                              <div className={`${meta.touched && meta.error ? 'display-block invalid-message' : 'display-none'} rounded h-8 mb-2 text-xs ease-in-out duration-300`}><ErrorMessage name="message"/></div>
                            </div>
                          )}
                        </FormikField>
                      </div>
                    </div>

                    <div className="flex flex-wrap -mx-3 mb-2 items-center">
                      <div className="w-full md:w-1/2 px-3">
                        <Button type="submit">Bericht versturen</Button>
                      </div>
                      <div className="w-full md:w-1/2 md:mt-0 xs:mt-2 px-3">
                        <ToastContainer/>
                      </div>
                    </div>

                  </FormikForm>
                </Formik>
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}
